import React, { useCallback } from "react";
import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	makeStyles,
} from "@material-ui/core";

import { makeMessages } from "../../utils/makeMessages";
import { Dialog } from "../Dialogs/Dialog";
import { ReservationFormBody } from "./ReservationFormBody";
import { ReservationFormWrapper } from "./ReservationFormWrapper";


export interface ReservationFormDialogProps {
	open: boolean;
	onClose: () => void,
}


export function ReservationFormDialog(props: ReservationFormDialogProps)  {
	const { open, onClose } = props;

	const classes = useStyles();
	const msg = useMessages();

	const handleClose = useCallback(() => onClose(), [onClose]);

	return (
		<Dialog maxWidth="md" {...{ open, onClose }} >
			<ReservationFormWrapper className={classes.dialogInner}>
				<DialogTitle>{msg.title}</DialogTitle>
				<DialogContent dividers>
					<ReservationFormBody variant="outlined" />
				</DialogContent>
				<DialogActions>
					<Button type="button" color="default" onClick={handleClose}>{msg.close}</Button>
					<Button type="submit" color="primary" autoFocus>{msg.submit}</Button>
				</DialogActions>
			</ReservationFormWrapper>
		</Dialog>
	);
}


const useStyles = makeStyles(theme => ({
	dialogInner: {
		display: 'flex',
		flexGrow: 1,
		flexDirection: 'column',
	}
}));


const useMessages = makeMessages({
	title: {
		sk: 'Rezervácia pobytu',
		en: 'Stay Reservation',
	},
	close: {
		sk: 'Zavrieť',
		en: 'Close',
	},
	submit: {
		sk: 'Odoslať',
		en: 'Submit',
	},
});
